<template>
  <div class="logout">
    <div class="centered">
      <h1 style="font-size: 8em">✌Fight On!</h1>

      <b-alert class="mt-4" variant="info" show>
        💡
        You have been logged off! <b-link @click="$router.push('/')"> Click here </b-link> to go back!
      </b-alert>
    </div>
  </div>
</template>

<script>

export default {
  name: "Logout",
  data: function() {
    return {
    };
  },
};

</script>

<style scoped>
html,
body {
  height: 100%
}

h1, h2, h3 {
  color: #990000;
}

.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

main {
  margin-bottom: 4.5rem;
  margin-top: 68px;
  text-align: left;
}

</style>
